module.exports = __webpack_public_path__ + "static/media/LogoCidadeJardim.8a1bde26.svg";